import { CloseButton } from '@mantine/core';

import classes from './CloseButton.module.css';

const CloseButtonDefaults = CloseButton.extend({
  defaultProps: { variant: 'subtle', iconSize: 24 },
  classNames: { root: classes.root },
});

export { CloseButton, CloseButtonDefaults };
